import React from "react";
import { Link } from "react-router-dom";

import winner1 from "../assets/ANDAH OYINDAMOLA-1.jpg?w=600&auto=format&fit=crop&q=60";
import winner2 from "../assets/OGUEJIOFOR NKEMAKONAM ANTHONY-1.jpg?w=600&auto=format&fit=crop&q=60";
import winner3 from "../assets/NWEKE CHINAMEZE BENJAMIN-1.jpg?w=600&auto=format&fit=crop&q=60";
import winner4 from "../assets/Goodness Adejare Aremu-1.jpg?w=600&auto=format&fit=crop&q=60";
import winner5 from "../assets/Divine Mercy-1.jpg?w=600&auto=format&fit=crop&q=60";
import winner6 from "../assets/Ajayi Olayink James-1.jpg?w=600&auto=format&fit=crop&q=60";

const winners = [
  { id: 1, name: "ANDAH OYINDAMOLA", school: "Francis Xavier High School, Lagos, Nigeria", image: winner1 },
  { id: 2, name: "OGUEJIOFOR NKEMAKONAM ANTHONY", school: "University of Lagos", image: winner2 },
  { id: 3, name: "NWEKE CHINAMEZE BENJAMIN", school: "University of Nigeria", image: winner3 },
  { id: 4, name: "GOODNESS ADEJARE AREMU", school: "University of Ibadan", image: winner4 },
  { id: 5, name: "DIVINE-MERCY ABIOYE", school: "Obafemi Awolowo University", image: winner5 },
  { id: 6, name: "AJAYI OLAYINKA JAMES", school: "  University of Ibadan", image: winner6 }
];

function Winners() {
  return (
    <section style={styles.container}>
      <h1>Winning Essays</h1>

      <style>{`
        .grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 30px;
          width: 100%;
        }

        @media (min-width: 600px) {
          .grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 992px) {
          .grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
      `}</style>

      <div className="grid">
        {winners.map((winner) => (
          <div key={winner.id} style={styles.card}>
            <img src={winner.image} alt={winner.name} style={styles.image} loading="lazy" />
            <h3>{winner.name}</h3>
            <p>{winner.school}</p>

            <Link to={`/essay/${winner.id}`}>
              <button style={styles.btn}>Read Essay</button>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  container: {
    padding: "40px 10px",
    textAlign: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
  },
  card: {
    background: "#f9f9f9",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
    textAlign: "center",
    width: "100%"
  },
  image: {
    width: "100%",
    height: "auto",
    display: "block", 
    objectFit: "cover",
    borderRadius: "10px"
  },
  btn: {
    marginTop: "15px",
    padding: "10px 20px",
    background: "#19195f",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer"
  }
};

export default Winners;
